<div
  *ngIf="!readOnly"
  ng2FileDrop
  [ngClass]="{ 'file-over': hasDropZoneOver }"
  (fileOver)="fileOver($event)"
  [uploader]="uploader"
  class="panel"
  [class.error]="doesFormHaveError"
  fxLayout="column"
  fxLayoutAlign="center center"
  (click)="documentUpload.click()"
>
  <div fxLayout="column" fxLayoutAlign="center center">
    <mat-icon class="upload-icon">cloud_upload</mat-icon>
    <p class="small-font"><b>BROWSE FILES</b></p>
    <p class="small-font">Drag and Drop Files Here</p>
  </div>
  <input
    type="file"
    id="documentUpload"
    #documentUpload
    ng2FileSelect
    (change)="documentUpload.value = ''"
    [uploader]="uploader"
    multiple
  />
</div>
<mat-error class="mat-error-document" [class.error]="doesFormHaveError">{{ errorMessage }}</mat-error>
<div fxLayout="column">
  <div *ngFor="let file of files">
    <div fxFlex class="files-panel">
      <div
        fxLayout="row"
        fxLayoutAlign="start center"
        fxFlex="95"
        class="file-card"
        [class.file-card-error]="file.hasError"
        [class.file-card-success]="file.isTempFile && !file.isUploading && !file.hasError"
      >
        <div fxLayout="row" fxLayoutAlign="space-between center" fxFlex>
          <div fxLayout="row" fxLayoutAlign="start center">
            <mat-icon *ngIf="!file.isUploading && !file.hasError">task</mat-icon>
            <mat-icon *ngIf="file.hasError">sd_card_alert</mat-icon>
            <div *ngIf="file.isUploading && !file.hasError" class="waiting-spinner">
              <mat-spinner strokeWidth="2" diameter="24"></mat-spinner>
            </div>
            <span>{{ file.fileName }}</span>
          </div>
          <span *ngIf="file.hasError" class="file-error-message">{{ file.errorMessage }}</span>
        </div>
      </div>
      <div fxFlex="5" *ngIf="!readOnly">
        <button
          mat-icon-button
          aria-label="Delete button"
          *ngIf="!file.isUploading || file.hasError"
          [disabled]="!file.isTempFile && !personDetailsMode && !isTeamDetailsMode"
          (click)="deleteFile(file)"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </div>
      <div fxFlex="5" *ngIf="!personDetailsMode && !isTeamDetailsMode">
        <button
          [disabled]="file.isTempFile"
          mat-icon-button
          aria-label="Download btton"
          *ngIf="!file.isUploading || file.hasError"
          (click)="onDownloadFile(file)"
        >
          <mat-icon>download</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
